import React from "react";
import { Link } from "react-router-dom";

// Images

// Video
import video from "../../assets/videos/video.mp4";

// Styles
import "../../assets/styles/sections/heroHome.scss";

const HomeHero = () => {
  return (
    <section className="heroHome">
      <div className="bg">
        <video autoPlay muted loop className="background-video">
          <source src={video} type="video/mp4" />
        </video>
      </div>
      <div className="containers">
        <div className="hero_items">
          <div className="content">
            <h2>Good choice Good interior</h2>
            <p className="moto">
              Choose suitable <br /> furniture for your <br /> interior with us
            </p>

            <Link className="serviceLink">Our Service</Link>
          </div>
          <div className="hero_shape"></div>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
